export default __webpack_public_path__ + "static/media/whyChooseUsIcon2.1277fc87.webp";